// extracted by mini-css-extract-plugin
export default {"banner":"UF9oOvRHljjmzMISg_cS","dot":"mDffgpTsCbTEuFsxIGVc","text":"O43Gu7GVHDKtaZBuAi7f"};